import { CurriculumVideoProductAPIStat, CurriculumVideoProductUIStat } from '~/redux/apis/user-stats-api'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

import { getVideoProgressData } from '../utils/get-video-progress-data.utils'

export default function useCurriculumVideoCardStats(
  productStat: CurriculumVideoProductAPIStat,
): CurriculumVideoProductUIStat {
  const {
    subjectTitle,
    title,
    id,
    timeSpent,
    summary: { totalSetsCount, setsCompletedCount, totalCorrectAnswersCount, totalIncorrectAnswersCount },
    video: {
      totalCount: totalVideoCount,
      watchedCount: watchedVideoCount,
      watchedDuration: videoWatchedDuration,
      videoLinks,
    },
    path,
  } = productStat

  const { days: timeSpentDays, hours: timeSpentHours, minutes: timeSpentMinutes } = convertMsToDayHourMinute(timeSpent)

  const videoProgressBarData = getVideoProgressData(watchedVideoCount, totalVideoCount, videoLinks)
  const {
    days: videoWatchedDays,
    hours: videoWatchedHours,
    minutes: videoWatchedMinutes,
  } = convertMsToDayHourMinute(videoWatchedDuration ?? 0)
  const activitySetsProgress = Math.floor((setsCompletedCount / totalSetsCount) * 100)
  const formatActivitySetsProgress = !isNaN(activitySetsProgress) ? activitySetsProgress : 0
  const totalAnswered = totalCorrectAnswersCount + totalIncorrectAnswersCount

  const correctAnswerPercentageNumber = Math.floor((totalCorrectAnswersCount / totalAnswered) * 100)
  const correctAnswerPercentage = isNaN(correctAnswerPercentageNumber) ? 0 : correctAnswerPercentageNumber

  return {
    id,
    subjectTitle,
    title,
    timeSpent: {
      days: timeSpentDays,
      hours: timeSpentHours,
      minutes: timeSpentMinutes,
    },
    activitiesSummary: {
      totalSetsCount,
      setsCompletedCount,
    },
    activitySetsProgress: formatActivitySetsProgress,
    correctAnswerPercentage,
    videoProgress: {
      days: videoWatchedDays,
      hours: videoWatchedHours,
      minutes: videoWatchedMinutes,
    },
    video: { totalCount: totalVideoCount, watchedCount: watchedVideoCount, watchedDuration: videoWatchedDuration },
    videoProgressBarData,
    totalAnswered,
    productHref: path,
  }
}
